export default __webpack_public_path__ + "static/primakulebsi-2ba535ec5a8369cc45888794686cc69c.jpg";